<template>
  <div>
    <QS-scroller-box>
      <!-- --开始------订单基本信息------------- -->
      <div class="details_content_repeat">
        <QS-h4-title title="订单基本信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="baseInfoList"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!-- --结束------订单基本信息------------- -->

      <!-- --开始------订单签约信息------------- -->
      <div class="details_content_repeat">
        <QS-h4-title title="订单签约信息" />
        <div class="details_content_repeat_hundred">
          <!-- 线下 -->
          <template v-if="computedOrderData.signType === 0">
            <el-form :model="orderSigningDefault">
              <column-box-expand :column="1">
                <el-form-item
                  :label="'合同模板' + columnSeparator"
                  class="alone"
                >
                  <el-select
                    v-model="orderSigningDefault.templateId"
                    placeholder="请选择"
                    :clearable="true"
                    :filterable="true"
                    :disabled="isHaveTemplate"
                  >
                    <el-option
                      v-for="item in contractList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    @click="getPreview"
                    :disabled="prewDisabled"
                    type="primary"
                    >预览</el-button
                  >
                </el-form-item>
                <el-form-item
                  required
                  :label="'签署方式' + columnSeparator"
                  class="alone"
                >
                  线下签署租赁合同
                </el-form-item>
                <el-form-item
                  required
                  :label="'合同附件上传' + columnSeparator"
                  class="alone"
                >
                  <UploadCommon
                    :fileList="archiveUrlList"
                    :limit="1"
                    :drag="true"
                    listType="text"
                    :sizeType="4"
                    acceptType=".pdf,.png,.jpg,.jpeg,.webp"
                    commonUpload
                    group="order"
                    code="order_contract_attachment_file"
                  ></UploadCommon>
                </el-form-item>
                <!--
                  【PKXW-2697】车辆-租赁管理-个人租赁订单，签约时不显示押金
                  <el-form-item
                  required
                  :label="'应收押金' + columnSeparator"
                  class="alone"
                >
                  {{ computedOrderData.receivableDeposit }}
                </el-form-item> -->
              </column-box-expand>
            </el-form>
          </template>

          <!-- 线上 -->
          <template v-else>
            <el-form>
              <column-box-expand :column="3">
                <el-form-item
                  required
                  :label="'合同模板' + columnSeparator"
                  class="alone"
                >
                  <el-select
                    v-model="orderSigningDefault.templateId"
                    placeholder="请选择"
                    :clearable="true"
                    :filterable="true"
                    :disabled="isHaveTemplate || onlineDisabled"
                  >
                    <el-option
                      v-for="item in contractList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                  <el-button
                    :disabled="prewDisabled"
                    @click="getPreview"
                    type="primary"
                    >预览</el-button
                  >
                </el-form-item>
                <el-form-item required :label="'签署方式' + columnSeparator">
                  线上签署（e签宝）
                </el-form-item>
                <el-form-item required :label="'合同编号' + columnSeparator">
                  {{ computedOrderData.orderId || '-' }}
                </el-form-item>
                <el-form-item required :label="'e签宝签署流程ID' + columnSeparator">
                  {{
                    computedOrderData.signId || computedOrderData.signId === 0
                      ? computedOrderData.signId
                      : '--'
                  }}
                </el-form-item>
                <el-form-item
                  required
                  :label="'合同签署状态' + columnSeparator"
                >
                  {{
                    computedOrderData.contractStateName
                      ? computedOrderData.contractStateName
                      : ''
                  }}
                </el-form-item>
                <div
                  v-if="onlineBtnTxt"
                  class="alone"
                  style="padding-left: 150px"
                >
                  <el-button
                    @click="openSignConfirm"
                    type="primary"
                    style="width: 200px"
                    >{{ onlineBtnTxt }}</el-button
                  >
                </div>
                <el-form-item
                  class="alone"
                  required
                  :label="'已签合同附件' + columnSeparator"
                >
                  <div
                    v-if="computedOrderData.computedContractUrl && computedOrderData.contractState !==6"
                    v-down="{
                      url: computedOrderData.computedContractUrl,
                      name: '合同附件',
                    }"
                    class="comm-down-text-color"
                  >
                    {{'合同附件' + computedContractUrlWithoutQueryString }}
                  </div>
                  <div v-else>--</div>
                </el-form-item>
                <!--
                  【PKXW-2697】车辆-租赁管理-个人租赁订单，签约时不显示押金
                  <el-form-item
                  required
                  :label="'应收押金' + columnSeparator"
                  class="alone"
                >
                  {{ computedOrderData.receivableDeposit }}
                </el-form-item> -->
              </column-box-expand>
            </el-form>
          </template>
        </div>
      </div>
      <!-- --结束------订单签约信息------------- -->

      <!--客户信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="客户信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="customerInformation"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!--客户信息 结束-->

      <!--车辆信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="车辆信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="ehicleInformation"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
      </div>
      <!--维保方案-->
      <!-- <div class="details_content_repeat">
        <QS-h4-title title="维保方案" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="maintenancePlan"
            :separator="columnSeparator"
            label-width="150"
          >
          </column-box-expand>
        </div>
    </div> -->
      <!--租赁信息-->
      <div class="details_content_repeat">
        <QS-h4-title title="租赁信息" />
        <div class="details_content_repeat_hundred">
          <column-box-expand
            :source="computedOrderData"
            :list="leaseInformation"
            :separator="columnSeparator"
            label-width="160"
          >
          </column-box-expand>
        </div>
        <LadderScheme
          :ladderSchemeList="computedOrderData.piecewiseConfigList || {}"
          :titleList="titleList"
        />
      </div>
      <template slot="bottomAction">
        <el-button
          @click="confirmSubmit(0)"
          v-if="
            computedOrderData.signType === 0 && computedOrderData.state === 0
          "
          :loading="oLoading.submit"
          size="small"
          >保存信息并返回列表</el-button
        >
        <el-button v-else @click="goPageBack" size="small">返回列表</el-button>
        <el-button
          v-if="
            computedOrderData.state === 0
          "
          @click="confirmSubmit(1)"
          :loading="oLoading.submit"
          type="primary"
          size="small"
          >确认订单签署信息</el-button
        >
      </template>
    </QS-scroller-box>
  </div>
</template>

<script>
// import LadderScheme from '@/components/LadderScheme'
import LadderScheme from '@/pages/orders/leaseScheme/personal/components/ladderScheme.vue'
import { contractTmpList } from '@/api/domain/organize'
import { leaseOrderStartSign, leaseOrderInvalidSign, leaseOrderCancelSign, leaseContractOrderConfirm } from '@/api/domain/orders'

export default {
  name: 'OrderInformation',
  props: {
    computedOrderData: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    LadderScheme,
  },
  data() {
    return {
      titleList: [
        {
          label: '阶梯',
          value: '',
        },
        {
          label: '起止月数',
          value: 'ladderDate',
        },
        {
          label: '租金(元)',
          value: 'amount',
        },
      ],
      oLoading: {
        submit: false,
      },
      signData: {
        text: '',
      },
      // 维保方案
      /* maintenancePlan: [
        { key: 'providerName', name: '维修厂' },
        { key: 'maintenancePlanName', name: '维保方案' },
      ], */
      // 租赁合同基本信息左侧key值
      baseInfoList: [
        {
          key: 'id',
          name: '订单ID',
        },
        {
          key: 'stateName',
          name: '订单状态',
        },
        {
          key: 'gmtCreate',
          name: '订单创建时间',
        },
        {
          key: 'confirmTime',
          name: '订单确认时间',
        },
        {
          key: 'outStockTime',
          name: '验车出库时间',
        },
        {
          key: 'returnCarTime',
          name: '退车发起时间',
        },
        {
          key: 'inStockTime',
          name: '验车入库时间',
        },
        {
          key: 'closeTime',
          name: '订单关闭时间',
        },
        {
          key: 'settlementStateName',
          name: '订单结算状态',
        },
        {
          key: 'relatedOrderIdName',
          name: '是否关联订单',
        },
        {
          key: 'rderRelatedReasonName',
          name: '关联原因',
        },
      ],
      contractList: [],
      customerInformation: [
        {
          key: 'customerTypeName',
          name: '客户类型',
        },
        {
          key: 'customerId',
          name: '客户ID',

        },
        {
          key: 'customerName',
          name: '客户名称',
        },
      ],
      ehicleInformation: [
        {
          // 车型ID到时候需要转
          key: 'modelName',
          name: '订单车型',
        },
        {
          key: 'plateNo',
          name: '绑定车辆',
        },
        {
          key: 'carId',
          name: '车辆ID',
        },
        {
          key: 'inventoryStateName',
          name: '车辆库存状态',
        },
      ],
      leaseInformation: [
        {
          key: 'planName',
          name: '方案模板名称',
        },
        {
          key: 'planRecordId',
          name: '上架单ID',
        },
        {
          key: 'signDate',
          name: '合同签署日期',
        },
        {
          key: 'receivablePeriod',
          name: '收款起止日',
        },
        {
          key: 'payDay',
          name: '缴款日',
        },
        {
          key: 'presentDaysName',
          name: '赠送天数',
        },
        {
          key: 'freeCycle',
          name: '免租周期',
        },
        {
          key: 'totalAmount',
          name: '租金总金额',
          finance: true,
        },
        {
          key: 'payModeName',
          name: '租金收款方式',
        },
        {
          key: 'totalDeposit',
          name: '押金总金额',
          finance: true,
        },
        {
          key: 'remarks',
          name: '备注',
        },
        {
          key: 'rentCategory',
          name: '租赁类别',
        },
        {
          key: 'isOpen',
          name: '租赁方案性质',
        },
      ],
      orderSigningDefault: {
        signChannelName: '线下签署合同',
        templateId: '',
      },
      archiveUrlList: [],
    }
  },
  created() {
    this.getContractTmpList()
    this.judgePermission('driver_customer_list_detail') && this.setCustomPath()
    this.judgePermission('vehicle_list_detail') && this.setCarIdPath()
  },
  inject: ['orderData', 'getDetails'],
  computed: {
    // 预览按钮禁用状态
    prewDisabled() {
      return !this.orderSigningDefault.templateId && this.orderSigningDefault.templateId !== 0
    },
    // 根据是否有方案ID
    isHaveTemplate() {
      return Boolean(this.computedOrderData.planId)
    },
    // 线上签约时是否让select选择，根据合同状态进行区分
    onlineDisabled() {
      // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中
      const stateList = [1, 2, 7]
      return stateList.includes(this.computedOrderData.contractState)
    },
    // 线上签约按钮的文字
    onlineBtnTxt() {
      if (this.computedOrderData.signType === 0) {
        return ''
      } else if (this.computedOrderData.contractState || this.computedOrderData.contractState === 0) { // 合同状态
        let _text = null
        // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中
        switch (this.computedOrderData.contractState) {
          case 0:
            // 待发起
            _text = '发起线上签署'
            break
          case 1:
            // 签署中
            _text = '撤回签署合同'
            break
          case 2:
            // 签约成功
            _text = '作废已签合同'
            break
          case 3:
            // 签约失败
            _text = '重新发起签署'
            break
          case 5:
            // 已撤回
            _text = '重新发起签署'
            break
          case 6:
            // 已作废
            _text = '重新发起签署'
            break
          case 7:
            // 撤回中
            _text = '再次发起撤回'
            break
          default:
            _text = ''
            break
        }
        return _text
      } else {
        return '发起线上签署'
      }
    },
    computedContractUrlWithoutQueryString() {
      const computedContractUrl = this.computedOrderData.computedContractUrl.slice(this.computedOrderData.computedContractUrl.lastIndexOf('.'))
      return computedContractUrl.indexOf('?') > -1 ? computedContractUrl.split('?')[0] : computedContractUrl
    },
  },
  watch: {
    computedOrderData: {
      handler(val) {
        if (val && val.orderId) {
          this.setData()
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 设置值
    setData() {
      this.orderSigningDefault.templateId = this.computedOrderData.templateId
      this.archiveUrlList = this.computedOrderData.contractUrl
    },
    // 表单提交事件
    contractSubmitHandle() {
      // 0待发起/1签署中/2签约成功/3签约失败/5已撤回/6已作废/7撤回中
      const startState = [null, undefined, 0, 3, 5, 6]
      const revokeState = [1, 7]
      const voidState = [2]

      this.oLoading.submit = true

      // 执行签署操作
      if (startState.includes(this.computedOrderData.contractState)) {
        this.startHandle()
      }
      // 执行撤回操作
      if (revokeState.includes(this.computedOrderData.contractState)) {
        this.revokeHandle()
      }
      // 执行作废操作
      if (voidState.includes(this.computedOrderData.contractState)) {
        this.voidHandle()
      }
    },

    // 签署操作
    startHandle() {
      if (!this.orderSigningDefault.templateId) {
        this.$message.error('请选择合同模板')
        return
      }
      leaseOrderStartSign({
        orderId: this.computedOrderData.orderId,
        templateId: this.orderSigningDefault.templateId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },

    // 撤回操作
    revokeHandle() {
      leaseOrderCancelSign({
        id: this.computedOrderData.contractId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },

    // 作废操作
    voidHandle() {
      leaseOrderInvalidSign({
        id: this.computedOrderData.contractId,
      }).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.getDetails()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },

    // 获取合同末班模板列表
    getContractTmpList() {
      let _list = []
      contractTmpList({ state: 1 }).then(({ code, data }) => {
        if (code === 1) {
          _list = data.items
        }
      }).finally(() => {
        this.contractList = _list
      })
    },

    // 合同预览
    getPreview() {
      const id = this.orderSigningDefault.templateId
      if (id || id === 0) {
        window.open(
          `/preview?orderId=${this.computedOrderData.orderId}&templateId=${this.orderSigningDefault.templateId}`,
          '_blank',
        )
      } else {
        this.$message.error('请您先选择合同模板，再进行预览操作')
      }
    },

    // 弹窗确认事件
    openSignConfirm() {
      this.signData.text = `您确定${this.onlineBtnTxt}?`
      this.$confirm(this.signData.text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      })
        .then(() => {
          this.contractSubmitHandle()
        }).catch(() => null)
    },

    // 确认订单操作
    confirmSubmit(type) {
      let templateId = ''
      let archiveUrl = ''

      const postParams = {
        orderId: this.computedOrderData.orderId,
        confirmFlag: type, // 0保存 1确认
      }

      if (this.computedOrderData.signType === 0) {
        templateId = this.orderSigningDefault.templateId
        if (this.orderSigningDefault.templateId || this.orderSigningDefault.templateId === 0) {
          postParams.templateId = templateId
        }

        if (this.archiveUrlList.length) {
          archiveUrl = this.getUoloadCommonFileData(this.archiveUrlList)
          postParams.archiveUrl = archiveUrl
        } else if (type === 1) {
          this.$message.error('请上传合同附件')
          return
        }
      } else {
        templateId = this.orderSigningDefault.templateId
        if (this.orderSigningDefault.templateId || this.orderSigningDefault.templateId === 0) {
          postParams.templateId = templateId
        } else {
          this.$message.error('请选择合同模板')
          return
        }
      }
      this.oLoading.submit = true
      leaseContractOrderConfirm(postParams).then(({ code }) => {
        if (code === 1) {
          this.$message.success('操作成功')
          this.goPageBack()
        }
      }).finally(() => {
        this.oLoading.submit = false
      })
    },

    // 返回列表页面
    goPageBack() {
      this.$router.push({
        path: '/workbench/rentOrder/list',
      })
    },

    setCustomPath() {
      const path = {
        path: '/driver/customerManage/detail',
        name: 'driver_customer_list_detail',
        query: {
          id: this.computedOrderData.customerId,
          customerType: this.computedOrderData.customerType,
        },
      }
      this.$set(this.customerInformation[1], 'goPage', path)
    },

    // 设置车辆ID跳转路径
    setCarIdPath() {
      const path = {
        path: '/vehicle/vehicleManage/detail',
        name: 'vehicle_list_detail',
        query: {
          id: this.computedOrderData.carId,
        },
      }
      this.$set(this.ehicleInformation[2], 'goPage', path)
    },
  },
}
</script>
